import UserService from "app/services/userService";
import Notify from "components/Notify";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
interface Params {
  token: string;
}
const Active = () => {
  const params: Params | any = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    UserService.active(params.token).then((data) => {
      let message =
        "Félicitations votre compte vient d'être activer, Vous pouvez désormais vous connecter!";
      let status = "success";
      if (data != "ok") {
        message = "Votre déjà activé, Vous pouvez désormais vous connecter!";
        status = "warning";
      }

      toast.custom((t) => <Notify t={t} message={message} status={status} />, {
        position: "top-right",
        id: "nc-product-notify",
        duration: 3000,
      });
      navigate("/login");
    });
  }, []);
  return <>{params.token}</>;
};

export default Active;
